<template>
    <a-card class="voice-doing">
      <div style="margin-top: 20px">
        语音核查总进度
      </div>
      <div class="info-panel " style="text-align: center;margin-bottom: 60px">
        <div>
           {{description}} <label class="info">{{(end=='1'?infoData.num:infoData.current) || 0}}/{{(infoData.num) || 0}}</label>人
        </div>
        <a-progress style="width: 80%" :percent="percent" />
      </div>
      <a-divider />
      <div class="fir-row">
        受试者核查进度
      </div>
      <div>
        <a-row class="info-panel" >
          <a-col :span="4">
            受试者名称：{{infoData.currentPatient?(infoData.currentPatient.name||'-') : '-'}}
          </a-col>
          <a-col :span="4">
            受试者编号：{{infoData.currentPatient?(infoData.currentPatient.patientNum) : '-'}}
          </a-col>
        </a-row>
        <a-divider />
      </div>
      <!--<div class="info-panel fir-row">-->
        <!--<a-steps :current="currentStep">-->
          <!--<a-step>-->
            <!--<template slot="title">-->
              <!--音频降噪-->
            <!--</template>-->
            <!--&lt;!&ndash;<span slot="description">This is a description.</span>&ndash;&gt;-->
          <!--</a-step>-->
          <!--<a-step title="音频合并转写" />-->
          <!--<a-step title="NLP语义解析"  />-->
          <!--<a-step title="校对核查"  />-->
        <!--</a-steps>-->
      <!--</div>-->
    </a-card>
</template>

<script>
  import { getAction ,postAction} from '@/api/manage'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'VoiceDoing',
    props:{

    },
    data(){
      return{
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        infoData:{},
        end:'',
      }
    },
    computed:{
      description(){
        if(this.infoData.isChecked){
          return '正在语音核查中'
        }else{
          if(this.end=='1' && this.infoData.num){
            return '已完成'
          }else{
            return '未开始'
          }
        }
      },
      current(){
        if(this.end=='1'){
          return this.infoData.num
        }else{
          return this.infoData.current
        }
      },
      percent(){
        if(!this.infoData.num){
          return 0
        }
        return parseFloat(((this.current || 0) / (this.infoData.num || 0) * 100).toFixed(2));
      },
    },
    mounted(){

    },
    methods:{
      start(voiceApplyId){
        if(this.timer){
          clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          getAction('/patient/patientVoice/progress',{voiceApplyId:voiceApplyId}).then(res=>{
            if(res.success){
              // 没有在核查中
              if(!res.result.isChecked){
                this.end = '1'
                if (this.timer) {
                  clearInterval(this.timer)
                  this.timer = null
                }
                this.infoData.isChecked = false
              }else{
                this.infoData = res.result
              }
            }
          })
        }, 1000)
      },
    }
  }
</script>

<style scoped lang="less">
  .voice-doing{
    .info{
      color: #2b5e7d;
    }
    .info-panel{
      margin: 40px;
    }
    .fir-row{
      margin-top: 50px;
    }
  }
</style>